export default __webpack_public_path__ + "static/media/creative-landing.fe3868a2.png";